import React,{useState,useEffect} from 'react'
import './Yangiliklar.css'
import axios from 'axios'
import { Link } from 'react-router-dom'
import Pagination from '@mui/lab/Pagination'
import photo from "../../assets/Photo"

const Yangiliklar=()=> {

  const[news,setNews]=useState([])
  const [page,setPage]=useState(1)

  const loadPhoto =async()=>{
    const res=await axios.get(`https://jsonplaceholder.typicode.com/photos?_page=${page}`)
    setNews(res.data)
  }
 useEffect(()=>{
   loadPhoto()
 },[page])
  
  return (
    <>
    <div className="Navigator">
       <div className="Navigator__from"><Link to='/'>Home</Link></div>
       <div className="Navigator__line"></div>
       <div className="Navigator__to">Yangiliklar</div>
     </div>
     <div className='Newss'>

       <div className='Cards'>
         {
           
     news.map((item,index)=>{
       return(
        
        <div className='News__card' key={index}>
       <Link to={`/newinfo/${item.id}`}>
       <img src={item.url} className='card__img' alt="" />
       <div className='News__card-info'>
       <div className='head'>2022-yil Universitetimizda yangi fakultetlar ochilmoqda</div>
       <div className='description'>{(item.title).slice(0,110)}...</div>
       </div>
        </Link> 
        </div>
      
      )
     })
     
}
     
     </div>
     <div className='pagination'>
       
       <Pagination count={23} 
       color={"primary"}
       defaultPage={page}
       boundaryCount={2}
       siblingCount={0}
       onChange={(event,value)=>setPage(value)}
       size="large"
       />
     
       </div>
     </div>
     
    </>
  )
}
export default  Yangiliklar
